'use strict';
import 'promise-polyfill/src/polyfill';
import '@/dss-common/style/base.css';
import '@/dss-common/partial/key-header/tpl.less';
import '@/dss-common/partial/key-footer/tpl.less';
import '@wakeadmin/components/style/index.scss';
import '../css/base.less';
import '../views/partial/banner/tpl.less';
import 'element-ui/lib/theme-chalk/index.css';
import getUserInfo from '@/dss-common/partial/key-header/tpl';
import Vue from 'vue';
import App from '../modules/login/App';
import ElementUI from 'element-ui';
import { plugin } from '@wakeadmin/components';
window.Promise = Promise;

Vue.use(plugin);
Vue.use(ElementUI);

function gotoHome() {
  window.top.location.href = '/';
}

getUserInfo.done((res) => {
  gotoHome();
});
new Vue({
  render: (h) => h(App),
}).$mount('#login-div');
